// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"503":"ab025fb6","640":"0c0e86d4","787":"87c0c23f"}[chunkId] + ".chunk.js";
};